import React from 'react'
import {_GPY,__GPYPost} from '../env.js'

import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';

const SortableItem = SortableElement(({value}) => {
  return (
      <li className="list-group-item">
        <div className="row">
          <div className="col-3">
            <img style={{maxWidth : '50px', maxHeight : '50px'}} src={"http://192.168.2.143:5050/"+value.name+".png"} className="img-fluid" alt="Avatar"/>
          </div>
          <div className="col-9">
            <small className="mb-1"><span className={value.status==="loadAndPlay"?"glyphicon glyphicon-play":"glyphicon glyphicon-pause"} aria-hidden="true"/> {value.name} {_GPY.secondsToTime(value.seconds)}</small>
          </div>
        </div>
      </li>
   )
});
const SortableList = SortableContainer(({items}) => {
  return (
    <ul class="list-group">
    {items.map((value, index) => (
        <SortableItem key={`item-${value.name}`} index={index} value={value} />
    ))}
    </ul>
  );
});

class Casper extends React.Component {

  constructor (props) {
	    super(props)
      this.files = {};

      this.state = {
        showCasperCGPanel: _GPY.uiStates.showCasperCGPanel!==undefined?_GPY.uiStates.showCasperCGPanel:false,
        playList:[],
        playPointer:0,
        playTime:0,
        playMaxTime:0,
        playLeft:0,
        mode:"stop",
        currentPlayingFile:"unknown",
        stateName: "CasparCG",
		  }
	}

  componentDidMount() {
    if(this.props.scoreboard !== undefined && this.props.scoreboard.registerComponent !== undefined){
       this.props.scoreboard.registerComponent(this.state.stateName,this);
    };
  }

  connect(){
  }

  reconnect() {
  }

  toggleCasperCGPanel(){
       var nv = !this.state.showCasperCGPanel;
       this.setState({showCasperCGPanel:nv},()=>{
         if(this.props.showCasperCGPanel !== undefined){
            this.props.showCasperCGPanel.forceUpdate();
         };
          __GPYPost('setUIState',{showCasperCGPanel:nv});
       });
  }

  createConnection() {
    console.log("ws://192.168.2.143:5050/guppyicg/");
    var connection = new WebSocket("ws://192.168.2.143:5050/guppyicg/");
  	connection.onopen =  () => {
  			connection.send("FILE::./media");
        connection.send("CG::THUMBNAIL ALL");
  	};

  	connection.onerror = (error) => {
  				console.log(error);
  	};

  	connection.onclose = (error) => {
  	};

  	connection.onmessage =  (e) => {

      var parts = e.data.split("::");
  		if(parts[0]==="FILE") {

  		  var d = JSON.parse(parts[1])
        var o = {};
        d.files.forEach((f, i) => {
  				var n = f.name.split('.');
          f.id = n[0];
          o[f.id] = f;
  				connection.send("CG::CINF "+n[0]);
        //  connection.send("CG::THUMBNAIL "+n[0]);
  			});
        // this.setState({files:o});
  		}
      if(parts[0]==="CG") {

          var firstLF = parts[1].indexOf("\n");
          var res = parts[1].substr(0,firstLF);
          var data = parts[1].substr(firstLF+1);

          console.log(firstLF,res,true,data);

          if(res === "201 INFO OK") {
              console.log("INFO");
              var parser = new DOMParser();
              var doc = parser.parseFromString(data, "text/xml");
              console.log(doc);

              var fileName = doc.evaluate( '//layer/foreground/producer/filename/text()', doc, null, XPathResult.STRING_TYPE, null ).stringValue;
              var fps = doc.evaluate( '//layer/foreground/producer/fps/text()', doc, null, XPathResult.NUMBER_TYPE, null ).numberValue;
              var frameNumber = doc.evaluate( '//layer/foreground/producer/frame-number/text()', doc, null, XPathResult.NUMBER_TYPE, null ).numberValue;
              var nbFrames = doc.evaluate( '//layer/foreground/producer/nb-frames/text()', doc, null, XPathResult.NUMBER_TYPE, null ).numberValue;

              var playTime = (frameNumber / fps);
              var playMaxTime = (nbFrames / fps);
              var playLeft = playMaxTime  - playTime;

              console.log(fps,frameNumber,nbFrames);
              var n = fileName.split('\\');
              var f = n[1].split('.');

              this.setState({playTime: playTime , playMaxTime: playMaxTime, playLeft: playLeft, currentPlayingFile:f[0]});

              if(5 === Math.floor(playLeft)) {
                this.loadNext();
              }

          } else if(res === "200 CINF OK") {

              console.log("FILEINFO",data);
              var inf = data.split(" ");
              if(inf[1] === "MOVIE") {
              var key = inf[0].replace(/"/g,'');

              var files = this.files;
              files[key] = {};
              files[key].name = key;
              files[key].type = inf[1];
              files[key].seconds = 0;

              files[key].frames = parseInt(inf[4]);
              var framesPerSec = parseInt(inf[5].split("/")[1]);
              files[key].framesPerSecond = framesPerSec;
              files[key].seconds = this.files[key].frames / framesPerSec;
          }
        }
      }
  	}

    this.setState({con:connection});

  }

  disconnect() {
  }

  addToPlayList(item){
    var pl = this.state.playList;
    pl.push(item);
    item.status="queue";

    this.setState({playList:pl});
  }

  getPlayListTime(){
    var pl = this.state.playList;
    var sum = 0;
    pl.forEach((item, i) => {
      sum += item.seconds;
    });
    return _GPY.secondsToTime(sum);
  }

  getPlayInfo(){
    this.state.con.send( "CG::INFO 1-9");
  }

  loadNext() {
    var pl = this.state.playList;
    var pointer = (this.state.playPointer);
    pl[pointer].status = "played";

    pointer++;
    if(pointer < pl.length) {
      this.state.con.send( "CG::LOADBG 1-9 " + (pl[pointer].name) + " MIX 20 AUTO");
      pl[pointer].status = "loadAndPlay";
      this.setState({playList:pl,playPointer:pointer,mode:"play"});
    }
}

  play () {
        var pl = this.state.playList;
        var pointer = (this.state.playPointer);
        this.state.con.send( "CG::PLAY 1-9 " + (pl[pointer].name) + " MIX 20 AUTO");
        pl[pointer].status = "loadAndPlay";

        this.setState({playList:pl,playPointer:pointer,mode:"play"},()=>{
          this.interval = setInterval(() => this.getPlayInfo(), (1000));
        });
  }

  stop(){
    clearInterval(this.interval);
    this.state.con.send( "CG::STOP 1-9");
  }
  pause(){
    clearInterval(this.interval);
    this.state.con.send( "CG::PAUSE 1-9");
  }
  resume(){
    this.state.con.send( "CG::RESUME 1-9");
    this.interval = setInterval(() => this.getPlayInfo(), (1000));
  }

   onSortEnd = ({oldIndex, newIndex}) => {
     this.setState(({playList}) => ({
       playList: arrayMove(playList, oldIndex, newIndex),
     }));
   };

   doFilter(k){
     var filter = this.state.fileFilter;
     if ( filter === undefined || filter === "" ) {
       return true;
     }
     var key = k[1].name;
     return key.toLowerCase().includes(filter);
   }


  render () {
    if(!this.state.showCasperCGPanel) {
      return ("");
    }
    return (<div className="col-4">

      <div className="row">
      <div className="col-6">
        <button onClick={(e)=>{this.createConnection()}}className="btn btn-success">Connect</button>
        <button onClick={(e)=>{this.forceUpdate()}}className="btn btn-success">forceUpdate</button>
        <button className="btn btn-danger" onClick={()=>{this.state.con.send( "CG::CLEAR 1-9")}}>CLEAN</button>
      </div>
      </div>

      <div className="row">

      <div className="col-6">
        <h6>available videos</h6>
        <input type="text" class="form-control" onChange={(e)=>{this.setState({fileFilter:e.target.value.toLowerCase()})}} placeholder="search"/>

        <div class="list-group" style={{ maxHeight: "600px", marginBottom: "10px", overflow:"scroll"}}>
        {Object.entries(this.files).filter((k)=>{ return this.doFilter(k) } ).map(([key,v],i) =>
          <div className="list-group-item">

          <div className="row">
            <div className="col-3">
              <img style={{maxWidth : '50px', maxHeight : '50px'}} src={"http://192.168.2.143:5050/"+key+".png"} className="img-fluid" alt="Avatar"/>
            </div>


            <div className="col-9">
            <div className="row">
              <div className="col-12">
                <small>{key}</small>
              </div>
              <div className="col-12">
               <button className="btn btn-light btn-sm" onClick={()=>{this.addToPlayList(v)}}><span class="glyphicon glyphicon-plus" aria-hidden="true"></span></button>
               <button className="btn btn-light btn-sm" onClick={()=>{this.addToPlayList(v)}}><span class="glyphicon glyphicon-search" aria-hidden="true"></span></button>
               <small className="pl-3">{_GPY.secondsToTime(v.seconds)}</small>
              </div>
            </div>
           </div>
          </div>
          </div>

        )}
        </div>
      </div>


      <div className="col-6">

                   <h3>TIME: {this.getPlayListTime()} </h3>
                   <h4>{_GPY.secondsToTime(this.state.playTime)} - {_GPY.secondsToTime(this.state.playMaxTime)} - {_GPY.secondsToTime(this.state.playLeft)}</h4>
                   {this.state.currentPlayingFile}
                   <div><button className="btn btn-info" onClick={()=>{this.play()}}>play</button>
                   <button className="btn btn-info" onClick={()=>{this.stop()}}>stop</button>
                   <button className="btn btn-info" onClick={()=>{this.pause()}}>Pause</button>
                   <button className="btn btn-info" onClick={()=>{this.resume()}}>resume</button></div>

        <h6>play queue</h6>
        <div class="list-group">
          <SortableList items={this.state.playList} onSortEnd={this.onSortEnd} />
        </div>
      </div>
      </div>

    </div>);
	 }
}
export default Casper
